import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, isRef as _isRef, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  style: {
    "display": "flex",
    "height": "100%",
    "min-height": "50vh"
  }
};
var _hoisted_2 = {
  class: "left"
};
var _hoisted_3 = {
  class: "search-container"
};
var _hoisted_4 = {
  style: {
    "display": "flex",
    "height": "100%",
    "flex-direction": "column"
  }
};
import { useCommonDialog } from '@/component-create/utils/hooks';
import { TREE_URL } from '@/api/system/department';
import { SearchForm } from '@/component-create/SearchForm';
import { Table } from '@/component-create/Table';
import { createFormItem } from '@/component-create/utils/create-form-item';
import { FORM_ITEM } from '@/components/form/enums';
import { createTableColumn } from '@/component-create/utils/create-table-column';
import { formatter as _formatter } from '@/utils/common';
import { USER_GENDER, USER_STATUS } from '@/constant/system/code';
import { PAGE_URL } from '@/api/system/mail-recipient';

import { ref, nextTick } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'MailUserInfoDialog',
  props: {
    title: {},
    defaultSelect: {},
    defaultMailContact: {}
  },
  emits: ['select'],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var activeName = ref('1');
    var dialog = useCommonDialog('userDialog');
    var searchForm = null;
    var table = null;
    var tab2SearchForm = null;
    var tab2Table = null;
    var searchFormRef = ref();
    var tableRef = ref();
    var tab2TableRef = ref();
    var tab2SearchFormRef = ref();
    function open() {
      dialog.open();
      if (!table || !searchForm) {
        nextTick(function () {
          renderSearchForm();
          renderTable();
          renderTab2SearchForm();
          renderTab2Table();
        });
      } else {
        initMailSelect();
        initSysSelect();
      }
    }
    function close() {
      dialog.close();
    }
    var SearchItems = [createFormItem('用户名', 'username', FORM_ITEM.INPUT, {
      clearable: true,
      maxlength: '20'
    }), createFormItem('昵称', 'nickname', FORM_ITEM.INPUT, {
      clearable: true,
      maxlength: '20'
    }), createFormItem('手机号码', 'phoneNumber', FORM_ITEM.INPUT, {
      clearable: true,
      maxlength: '11'
    }), createFormItem('性别', 'gender', FORM_ITEM.SELECT, {
      loader: 'USER_GENDER',
      allOption: true
    }), createFormItem('状态', 'status', FORM_ITEM.SELECT, {
      loader: 'USER_STATUS',
      allOption: true
    })];
    var Tab2SearchItems = [createFormItem('用户名', 'recipientName', FORM_ITEM.INPUT, {
      clearable: true,
      maxlength: '20'
    }), createFormItem('昵称', 'mailAddress', FORM_ITEM.INPUT, {
      clearable: true,
      maxlength: '20'
    })];
    var column = [{
      type: 'selection'
    }, {
      label: '序号',
      type: 'index',
      width: '60'
    }, createTableColumn('用户名', 'username', '120'), createTableColumn('昵称', 'nickname', '120'), createTableColumn('手机号码', 'phoneNumber', '120', 'center'), createTableColumn('邮箱', 'email', '200', undefined, {
      showOverflowTooltip: true
    }), createTableColumn('性别', 'gender', '60', 'center', {
      showOverflowTooltip: true,
      formatter: function formatter(row) {
        return _formatter(USER_GENDER, row.gender);
      }
    }), createTableColumn('状态', 'status', '60', 'center', {
      showOverflowTooltip: true,
      formatter: function formatter(row) {
        return _formatter(USER_STATUS, row.status);
      }
    }), createTableColumn('备注', 'remark', undefined, undefined, {
      showOverflowTooltip: true
    })];
    var column2 = [{
      type: 'selection'
    }, {
      label: '序号',
      type: 'index',
      width: '60'
    }, createTableColumn('联系人名称', 'recipientName', undefined), createTableColumn('邮箱地址', 'mailAddress', undefined), createTableColumn('备注', 'remark', undefined, 'center'), createTableColumn('创建时间', 'createdAt', '120', 'center')];
    /**
     * 绘制搜索表单
     */
    function renderSearchForm() {
      searchForm = new SearchForm(searchFormRef.value, SearchItems, {
        labelWidth: '80px'
      });
      searchForm.onSearch = function (formData) {
        var _table;
        (_table = table) === null || _table === void 0 || _table.load(formData);
      };
    }
    /**
     * 绘制搜索表单
     */
    function renderTab2SearchForm() {
      tab2SearchForm = new SearchForm(tab2SearchFormRef.value, Tab2SearchItems, {
        labelWidth: '80px'
      });
      tab2SearchForm.onSearch = function (formData) {
        var _tab2Table;
        (_tab2Table = tab2Table) === null || _tab2Table === void 0 || _tab2Table.load(formData);
      };
    }
    /**
     * 绘制表格
     */
    function renderTable() {
      table = new Table(tableRef.value, column, [], {
        border: true,
        rowKey: 'id'
      }, 'system/user/page');
      table.onLoaded = function () {
        nextTick(function () {
          initSysSelect();
        });
      };
    }
    /**
     * 绘制表格
     */
    function renderTab2Table() {
      tab2Table = new Table(tab2TableRef.value, column2, [], {
        border: true,
        rowKey: 'id'
      }, PAGE_URL);
      tab2Table.onLoaded = function () {
        nextTick(function () {
          initMailSelect();
        });
      };
    }
    function initSysSelect() {
      if (props.defaultSelect) {
        var _table2;
        (_table2 = table) === null || _table2 === void 0 || _table2.setSelectRowKeys(props.defaultSelect);
      }
    }
    function initMailSelect() {
      if (props.defaultMailContact) {
        var _tab2Table2;
        (_tab2Table2 = tab2Table) === null || _tab2Table2 === void 0 || _tab2Table2.setSelectRowKeys(props.defaultMailContact);
      }
    }
    function confirm() {
      var _table3, _tab2Table3;
      var selectRows = ((_table3 = table) === null || _table3 === void 0 ? void 0 : _table3.getSelectRows()) || [];
      var selectRows2 = ((_tab2Table3 = tab2Table) === null || _tab2Table3 === void 0 ? void 0 : _tab2Table3.getSelectRows()) || [];
      emits('select', {
        tab1: selectRows,
        tab2: selectRows2
      });
      close();
    }
    function cancel() {
      close();
    }
    __expose({
      open: open,
      close: close
    });
    return function (_ctx, _cache) {
      var _component_XSearchTree = _resolveComponent("XSearchTree");
      var _component_XFlexCtx = _resolveComponent("XFlexCtx");
      var _component_el_tab_pane = _resolveComponent("el-tab-pane");
      var _component_el_tabs = _resolveComponent("el-tabs");
      var _component_ElButton = _resolveComponent("ElButton");
      var _component_XCommonDialog = _resolveComponent("XCommonDialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_XCommonDialog, {
        ref: "userDialog",
        title: _ctx.title,
        width: "70%"
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("div", null, [_createVNode(_component_ElButton, {
            onClick: cancel
          }, {
            default: _withCtx(function () {
              return _cache[1] || (_cache[1] = [_createTextVNode("取消")]);
            }),
            _: 1
          }), _createVNode(_component_ElButton, {
            type: "primary",
            onClick: confirm
          }, {
            default: _withCtx(function () {
              return _cache[2] || (_cache[2] = [_createTextVNode("确认")]);
            }),
            _: 1
          })])];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_el_tabs, {
            modelValue: _unref(activeName),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _isRef(activeName) ? activeName.value = $event : null;
            }),
            class: "demo-tabs"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_tab_pane, {
                label: "系统用户",
                name: "1"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_XSearchTree, {
                    url: _unref(TREE_URL),
                    label: function label(item) {
                      return "".concat(item.departmentName, "(").concat(item.departmentCode, ")");
                    },
                    value: "departmentCode",
                    "el-tree-prop": {
                      showCheckbox: true
                    }
                  }, null, 8, ["url", "label"])]), _createVNode(_component_XFlexCtx, {
                    flex: 1
                  }, {
                    default: _withCtx(function () {
                      return [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
                        ref_key: "searchFormRef",
                        ref: searchFormRef
                      }, null, 512), _createVNode(_component_XFlexCtx, {
                        flex: 1
                      }, {
                        default: _withCtx(function () {
                          return [_createElementVNode("div", {
                            style: {
                              "height": "100%"
                            },
                            ref_key: "tableRef",
                            ref: tableRef
                          }, null, 512)];
                        }),
                        _: 1
                      })])];
                    }),
                    _: 1
                  })])];
                }),
                _: 1
              }), _createVNode(_component_el_tab_pane, {
                label: "邮件联系人",
                name: "2"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
                    ref_key: "tab2SearchFormRef",
                    ref: tab2SearchFormRef
                  }, null, 512), _createElementVNode("div", {
                    style: {
                      "height": "100%"
                    },
                    ref_key: "tab2TableRef",
                    ref: tab2TableRef
                  }, null, 512)])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["title"])]);
    };
  }
});